import React from 'react';
import { View } from 'react-native';
import Typography from '../../typography/Typography';
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { addCommasToNumber } from '../utils';
const ProcessingCharges = ({ processingFeeObject, }) => {
    const keysArray = Object.keys(processingFeeObject);
    const valuesArray = Object.values(processingFeeObject);
    return (React.createElement(View, null, keysArray.map((key, index) => (React.createElement(View, { key: index, style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: index === 0 ? 0 : 12 } },
        React.createElement(Typography, { label: keysArray[index], color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B2R }),
        React.createElement(View, { style: { marginLeft: 12 } },
            React.createElement(Typography, { label: `₹${addCommasToNumber(Number(valuesArray[index]))}`, color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B2M })))))));
};
export default ProcessingCharges;
